import { Component, OnInit } from '@angular/core';
import { UnityService } from 'src/app/services/unity.service';
import { Unity } from 'src/app/models/unity';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Component({
  selector: 'app-unities-report',
  templateUrl: './unities-report.component.html',
  styleUrls: ['./unities-report.component.css']
})
export class UnitiesReportComponent implements OnInit {

  unities:Unity[] = [];
  unitiesAll:Unity[] = [];
  loading:boolean = false;
  expand:boolean = false;

  customers:string[] = [];
  customer:string = null;
  unitTypes:string[] = [];
  unitType:string = null;
  ubications:string[] = [];
  ubication:string = null;
  isActive:number = 3;
  public active:boolean = null; //Todas la unidades

  constructor(private unityServ:UnityService, private utl:UtilitiesService) { }

  ngOnInit() {
    this.loading = true;
    this.unityServ.getUnities().then(unities => {
      this.unities = unities.filter(un => un.unit_type.name != 'Contratistas');

      for(let i = 0; i < this.unities.length; i++) {
        let un = this.unities[i];
        //add filters
        this.utl.createFilter(this.customers, un.customer.comercial_name);
        this.utl.createFilter(this.ubications, un.ubication);
        this.utl.createFilter(this.unitTypes, un.unit_type.name);
      }
      this.unitiesAll = this.unities;

      this.loading = false;
    });
  }

  filterAll() {
    if(this.isActive == 1)
      this.active = true; 

    if(this.isActive == 2)
      this.active = false;

    if(this.isActive == 3)
      this.active = null;

    if(this.active != null) 
      this.unities = _.filter(this.unities = this.utl.filterBy(this.utl.filterBy(this.utl.filterBy(this.unitiesAll, 'customer.comercial_name', this.customer ? [this.customer] : []), 'unit_type.name', this.unitType ? [this.unitType] : []), 'ubication', this.ubication ? [this.ubication] : []), ['active', this.active]);
    else
      this.unities = this.utl.filterBy(this.utl.filterBy(this.utl.filterBy(this.unitiesAll, 'customer.comercial_name', this.customer ? [this.customer] : []), 'unit_type.name', this.unitType ? [this.unitType] : []), 'ubication', this.ubication ? [this.ubication] : []);
  }

  download(type) {
    //window.open(environment.baseUrl + '/' + type + '/unities', '_blank');
    window.open(environment.baseUrl + '/' + type + '/unities?status=' + this.isActive.toString() + "&customer_id=" + this.customer + "&type_id=" + 
    this.unitType + "&ubication=" + this.ubication, '_blank')
  }
}
